import { MethodCallError } from '@gopay/miniapp-client';

export type SDKCallResult<Data = object> = {
  success: boolean;
  data?: Data;
  error?: MethodCallError;
};

export type NewSDKCallResult<Data = Record<string, unknown>> = {
  success: boolean;
  data?: Data;
  ret: string;
  error_code?: string;
  error_message?: string;
  error_type?: string;
};

export type ErrorOptions = {
  error?: {
    operation_key: OPERATION_KEY;
    code: number;
  };
};

export enum OPERATION_KEY {
  AUTHCODE = 'authcode',
  DEEPLINK = 'deeplink',
  PAYMENT = 'payment',
  LOCATION = 'location',
  SYSTEM = 'system',
  WIFI = 'wifi',
  CAMERA = 'camera',
  BANK_TOKEN = 'bankToken',
  CONSENT = 'consent',
}

export type ContainerCall = (
  className: string,
  methodName: string,
  params: Record<string, unknown>,
  successCallback: (result: unknown) => void,
  errorCallback: (err: unknown) => void
) => void;
